//hook
import useAcl from '@/utils/hooks/user/useAcl';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

//lib
import { NEW_PRICING } from '@/lib/acl/aclRightsList';

//components
import WrapperSettings from '@/components/pages/settings/WrapperSettings';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';

export const LoaderText = () => (
    <div className="border-b border-icoGray-300 p-8 dark:border-icoDarkMode-beton xl:px-7 xl:py-10 xl:pb-10">
        <div className="flex w-full animate-pulse flex-col space-y-m">
            <span className="block h-5 w-2/3 rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            <div className="mb-m flex w-full flex-col gap-2">
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <p className="h-3 w-full rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
        </div>
    </div>
);

function RightSectionLoading() {
    return (
        <WrapperSettings.WrapperSettingsLastColumn hideOnMobile={false}>
            {[1, 2, 3].map((el) => (
                <LoaderText key={el} />
            ))}
        </WrapperSettings.WrapperSettingsLastColumn>
    );
}

function OldLoadingPage() {
    return (
        <>
            <WrapperSettings.WrapperSettingsFirstColumn
                className="p-8 xl:px-20 xl:py-10"
                data-testid="old-plan-loading">
                <span className="mb-5 block h-5 w-44 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <div className="flex w-full animate-pulse flex-col gap-3">
                    <div className="h-[30rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                </div>
            </WrapperSettings.WrapperSettingsFirstColumn>
            <RightSectionLoading />
        </>
    );
}

function NewLoadingPage() {
    const { isTreeStructureActivated } = useActiveTreeStructure();

    if (isTreeStructureActivated) {
        return (
            <>
                <SettingsWrapper.MainContent data-testid="new-plan-loading">
                    <span className="mb-5 block h-5 w-44 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                    <div className="flex w-full animate-pulse flex-col gap-2.5">
                        <div className="h-[11.3rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                        {[1, 2, 3].map((el) => (
                            <div
                                key={el}
                                className="h-[5.375rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"
                            />
                        ))}
                    </div>
                </SettingsWrapper.MainContent>
                <SettingsWrapper.SideContent>
                    {[1, 2, 3].map((el) => (
                        <LoaderText key={el} />
                    ))}
                </SettingsWrapper.SideContent>
            </>
        );
    }

    return (
        <>
            <WrapperSettings.WrapperSettingsFirstColumn
                className="p-8 xl:px-20 xl:py-10"
                data-testid="new-plan-loading">
                <span className="mb-5 block h-5 w-44 animate-pulse rounded bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <div className="flex w-full animate-pulse flex-col gap-2.5">
                    <div className="h-[11.3rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                    {[1, 2, 3].map((el) => (
                        <div
                            key={el}
                            className="h-[5.375rem] w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"
                        />
                    ))}
                </div>
            </WrapperSettings.WrapperSettingsFirstColumn>
            <RightSectionLoading />
        </>
    );
}

export function PageLoading() {
    const { hasAcl } = useAcl();

    if (!hasAcl(NEW_PRICING.read)) {
        return <OldLoadingPage />;
    }

    return <NewLoadingPage />;
}
